import { Routes, Route } from 'react-router-dom'
import { Dashboard } from './pages/Dashboard'
import { RestaurantDetail } from './pages/RestaurantDetail'
import { ItemDetail } from './pages/ItemDetail'
import { PromptLibrary } from './pages/PromptLibrary'
import { BatchJobs } from './pages/BatchJobs'
import { Review } from './pages/Review'
import { Flagged } from './pages/Flagged'
import { SignInPage } from './pages/SignInPage'
import { Layout } from './components/Layout'
import { RequireAuth, RequireRole } from './auth/RequireRole'

function App() {
  return (
    <Routes>
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/" element={<RequireAuth><Layout /></RequireAuth>}>
        <Route index element={<Dashboard />} />
        <Route path="restaurant/:id" element={<RestaurantDetail />} />
        <Route path="item/:id" element={<ItemDetail />} />
        <Route path="review" element={<RequireRole roles={['reviewer', 'approver']}><Review /></RequireRole>} />
        <Route path="flagged" element={<RequireRole roles={['approver']}><Flagged /></RequireRole>} />
        <Route path="prompts" element={<RequireRole roles={['admin']}><PromptLibrary /></RequireRole>} />
        <Route path="batch" element={<RequireRole roles={['admin']}><BatchJobs /></RequireRole>} />
      </Route>
    </Routes>
  )
}

export default App
